import { Injectable } from '@angular/core';

import { Api } from './api';

@Injectable({
    providedIn: 'root'
})
export class ReportsApi {
    constructor(private readonly api: Api) { }

    async getVisibleAssetIds(layerId: number, columnName: string, query?: any) {
        if (query) {
            return await this.api.http2.graphqlRequest(`
                    query ($query: QueryInput!) {
                        layers(id: ${layerId}){
                            data(fieldNames: ["${columnName}"], query: $query)
                        }
                    }
            `, { query }, 'GET', 'layers');
        } else {
            return await this.api.http2.graphqlRequest(`
                    query {
                        layers(id: ${layerId}){
                            data(fieldNames: ["${columnName}"])
                        }
                    }
            `, {}, 'GET', 'layers');
        }
    }

    getProjectTotals(ids) {
        return this.api.report.post('api/reports/getProjectTotals', ids);
    }

    getBridgeReportData(bridgeId: number) {
        return this.api.report.get('api/reports/bridgeReport', { bridgeId }).catch(err => { throw err; });
    }

    getBridgeBasicReportData(bridgeId: number) {
        return this.api.report.get('api/reports/basicBridgeReport', { bridgeId }).catch(err => { throw err; });
    }

    getBridgeDataReportData(ids: number[]) {
        return this.api.report.post('api/reports/bridgeDataReport', ids).catch(err => { throw err; });
    }

    getProjectListReportData(ids: number[]) {
        return this.api.report.post('api/reports/projectList', ids).catch(err => { throw err; });
    }

    getIRIProjectEvaluationDraftTIPReportData(reportParams: any) {
        return this.api.report.post('api/reports/IRIProjectEvaluationDraftTIPReport', reportParams).catch(err => { throw err; });
    }

    getIRIProjectEvaluationTIPReportData(reportParams: any) {
        return this.api.report.post('api/reports/IRIProjectEvaluationTIPReport', reportParams).catch(err => { throw err; });
    }

    getOPIProjectEvaluationDraftTIPReportData(reportParams: any) {
        return this.api.report.post('api/reports/OPIProjectEvaluationDraftTIPReport', reportParams).catch(err => { throw err; });
    }

    getOPIProjectEvaluationTIPReportData(reportParams: any) {
        return this.api.report.post('api/reports/OPIProjectEvaluationTIPReport', reportParams).catch(err => { throw err; });
    }

    getPlanningStatsDraftTipReportData(planningPartner: string) {
        return this.api.report.get('api/reports/planningStatsDraftTipReport', { planningPartner }).catch(err => { throw err; });
    }

    getPlanningStatsTipReportData(planningPartner: string) {
        return this.api.report.get('api/reports/planningStatsTipReport', { planningPartner }).catch(err => { throw err; });
    }

    getProjectDetailReportData(projectId: string) {
        return this.api.report.get('api/reports/projectDetail', { projectId }).catch(err => { throw err; });
    }

    getProjectStatusReportData(projectId: string) {
        return this.api.report.get('api/reports/projectStatus', { projectId }).catch(err => { throw err; });
    }

    getSDBridgeReportData(bridgeIds: number[]) {
        return this.api.report.post('api/reports/sdBridgeReport', bridgeIds).catch(err => { throw err; });
    }

    getSDBridgeSummaryReportData(bridgeIds: number[]) {
        return this.api.report.post('api/reports/sdBridgeSummaryReport', bridgeIds).catch(err => { throw err; });
    }

    getHopDetailReportData(objectId: number) {
        return this.api.report.get('api/reports/hopDetail', { objectId }).catch(err => { throw err; });
    }

    getMunicipalityAssetTipReportData(countyCode: string, municipalId: string) {
        return this.api.report.get('api/reports/municipalityAssetTipReport', { countyCode, municipalId }).catch(err => { throw err; });
    }

    getMunicipalityAssetDraftTipReportData(countyCode: string, municipalId: string) {
        return this.api.report.get('api/reports/municipalityAssetDraftTipReport', { countyCode, municipalId }).catch(err => { throw err; });
    }

    getLegislativeAssetTipReportData(reportParams) {
        return this.api.report.post('api/reports/legislativeAssetTipReport', reportParams).catch(err => { throw err; });
    }

    getLegislativeAssetDraftTipReportData(reportParams) {
        return this.api.report.post('api/reports/legislativeAssetDraftTipReport', reportParams).catch(err => { throw err; });
    }

    generateCSV(reportParameters: any) {
        return this.api.report.post('api/csv/getCsvReport', reportParameters).catch(err => { throw err; });
    }
}
